/* eslint-disable react/prop-types */
import React from 'react';

import Styles from './index.css';

const DragIndicator: React.FC<{ style?: React.CSSProperties }> = props => (
    <div className={Styles['drag-indicator']} style={props.style}>
        <div className={Styles['drag-indicator-circle']} />
        <div className={Styles['drag-indicator-line']} />
    </div>
);

export default DragIndicator;
